module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-57x57-d6ecab65e40846d0b906f6426237481a.png";